import HttpClient from "./api";

class PostbackApi extends HttpClient {
    public constructor() {
        super();
    }

    simulatePostback(data: {
        postbackUrl: string,
        eventType: 'REGISTRATION' | 'QFTD',
        v: string,
        v2: string,
        httpMethod: 'GET' | 'POST'
    }) {
        return this.doPost('/api/v3/postback/simulate', data)
    }
}

export const postbackApi = new PostbackApi();
